import { axios, Response } from '../index'

const deletePersonaFile = (fileId: string): Response<null> => {
  return axios.delete(`/v1/files/${fileId}`)
}

export default deletePersonaFile
